import axios from "axios";
import config from "./config";

// cria instância configurada
const api = axios.create({
  baseURL: config.URL_API,
  timeout: 10000, // opcional (10s)
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Interceptor de requisição (antes de enviar)
// api.interceptors.request.use(
//   (config) => {
//     // Se tiver token salvo no localStorage/sessionStorage
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// Interceptor de resposta (depois da resposta)
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       console.warn("Não autorizado, faça login novamente!");
//       // opcional: redirecionar para login
//     }
//     return Promise.reject(error);
//   }
// );

export default api;
